import { request } from "#/utils/request";

interface IGetCadastroAtualizar {
  conta: string;
  coop: string;
  documento: string;
}

export interface IGetCadastroAtualizarData {
  data: Data;
  errors: Errors;
}

interface Data {
  id_pessoa: string;
  id_conta_bancaria: string;
}

interface Errors {
  message: string;
  code: number;
}

export const getCadastroAtualizar = async ({
  conta,
  coop,
  documento,
}: IGetCadastroAtualizar) => {
  return (
    await request.post<IGetCadastroAtualizarData>(
      `/cadastro/atualizar?conta=${conta}&coop=${coop}&documento=${documento}`
    )
  ).data;
};
